import React from "react";
import { Stack } from "react-bootstrap";
import { PageHeader } from "../../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import { HugeiconsIcon } from "@hugeicons/react";
import { City03Icon, Mosque02Icon } from "@hugeicons/core-free-icons/index";
import { Container } from "reactstrap";
import { FormPortsTab } from "./ReceptionCenter/FormPortsTab";

const CenterReceptionMadina = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const currentSource = searchParams.get("source") || "from_ports";

  const handleTabChange = (key) => {
    setSearchParams({ source: key });
  };

  const tabItems = [
    {
      key: "from_ports",
      label: t("FROM_PORTS"),
      icon: <HugeiconsIcon size={14} icon={Mosque02Icon} />,

    },
    {
      key: "between_cities",
      label: t("BETWEEN_CITIES"),
      icon: <HugeiconsIcon size={14} icon={City03Icon} />,

    },
  ];

  return (
    <Stack gap={3}>
      <PageHeader title={t("NUSUK_RECEPTION_MAKKAH")} sticky={false} />
      <Container fluid>
        <Tabs
          activeKey={currentSource}
          items={tabItems}
          onChange={handleTabChange}
          className="mb-3"
        />
        <FormPortsTab />
      </Container>
    </Stack>
  );
};

export default CenterReceptionMadina;
